import React from "react";
import { Link } from "react-router-dom";
import { MENU_ITEMS } from "@/constants/menu";
import { X } from "lucide-react";
import styles from "./Sidebar.module.css";

interface SidebarProps {
  isOpen: boolean;
  onClose: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ isOpen, onClose }) => {
  return (
    <aside className={`${styles.sidebar} ${isOpen ? styles.open : ""}`}>
      <button className={styles.closeButton} onClick={onClose}>
        <X size={28} />
      </button>

      <ul className={styles.sidebarItems}>
        {MENU_ITEMS.map((menu, index) => (
          <li key={index} className={styles.sidebarItem}>
            <Link to={menu.link} className={styles.sidebarLink}>
              {menu.displayName}
            </Link>
          </li>
        ))}
      </ul>
    </aside>
  );
};

export default Sidebar;
